import { Component, Input, SimpleChanges } from '@angular/core';
import { ConfigService, globalData, User, game } from 'baseline-lib';
import { Global } from '../../../global/global';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Generated class for the UserprofileComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'userprofile',
  templateUrl: 'userprofile.html'
})
export class UserprofileComponent {
  @Input() mainlink: game;
  
  text: string;
  httplink:any;
  constructor(public _configService:ConfigService,public globalData:Global,public sanitizer: DomSanitizer) {
    // if(localStorage.getItem("authUser") !== null && localStorage.getItem("authUser") !== ""){
    //   this.globalData.authUser = <User>JSON.parse(localStorage.getItem("authUser"));
    // }
    // this.httplink = this._configService.getOPASUrl().concat("myProfile/" + this.globalData.authUser.refToken +"/en");
    // console.log(this.httplink);
    // this.httplink=this.sanitizer.bypassSecurityTrustResourceUrl(this.httplink);
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.mainlink) {
      this.httplink =  changes.mainlink.currentValue ;
      this.httplink=this.sanitizer.bypassSecurityTrustResourceUrl(this.httplink);

    }
  }

}



// WEBPACK FOOTER //
// ./src/app/profile/userprofile/userprofile.ts